export const CUSTOM_STATE_KEY = 'custom';

/**
 * Custom state
 */
export interface CustomState {
  fonctionTypesOptions: any[] | null;
}
